import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { ArtComponent } from './art/art.component';
import { ProjectComponent } from './art/project.component';
import { ProjectResolver } from './art/project-resolver.service';
import { WorkComponent } from './work/work.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  {
    path: 'art',
    component: ArtComponent,
    children: [
      {
        path: ':project_id',
        component: ProjectComponent,
        resolve: {
          project: ProjectResolver
        }
      }
    ]
  },
  { path: 'work', component: WorkComponent}
];

export const AppRoutes = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.routing.ts